export default __webpack_public_path__ + "static/media/thankyou.443a14c0.svg";